export const colors = [
  "#e6194b", "#4363d8", "#3cb44b",
  "#f58231",
  "#911eb4", "#46f0f0", "#f032e6", "#bcf60c", "#fabebe", "#008080",
  "#e6beff", "#9a6324", "#fffac8", "#800000", "#aaffc3", "#808000"]
